// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3lEd7","title":"_2_92z","text":"RInYb"};